import styled from "styled-components";
import { Card } from "antd";

export const Container = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  @media screen and (max-width: 576px) {
    height: 450px;
  }
`;

export const Title = styled.span`
  font-size: 18px;
  font-weight: bold;
  font-family: "Asap", sans-serif;
`;

export const CardCustom = styled(Card)`
  margin-top: 13px !important;
  border-radius: 7px !important;
  background: #fff !important;
  box-shadow: 0px 0px 10px #d8d8d8 !important;
  padding: 0px !important;
  .ant-card-body {
    padding-top: 14px;
  }
  .rowHeader {
    margin-bottom: 17px;
  }
`;
